import { ModuleNavigationSubRoute, NavNode } from './module-navigation.models';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IModuleNavigationService {
	get moduleRouteTree(): NavNode[];
	registerDynamicSubRoute(root: string, routes: Array<ModuleNavigationSubRoute>): void;
}

// Create the injection token with the interface as its type
export const MODULE_NAVIGATION_SERVICE = new InjectionToken<IModuleNavigationService>('IModuleNavigationService');
